import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const DesigningOfIndustrialProcessPiping: React.FC = () => {
  return (
    <>
      <PageHeader title="Designing of Industrial Process & Piping" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Designing of Industrial Process & Piping</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Process & piping design is the foundation of any efficient chemical or industrial plant. At Wasser Technochem (India) Ltd., we offer comprehensive process design and piping engineering services for new and retrofit plants, covering water treatment, chemical processing, and utility systems.</p>
              <p>Our approach combines process simulation, PFDs, P&IDs, and detailed 3D modeling to ensure operational efficiency, safety, and ease of maintenance. With deep industry experience, we deliver solutions tailored to your exact chemical, mechanical, and thermal requirements.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-water text-primary me-2"></i>Water and wastewater treatment systems</p>
              <p><i className="fa fa-flask text-primary me-2"></i>Chemical and specialty chemical plants</p>
              <p><i className="fa fa-paint-brush text-primary me-2"></i>Paint, resin, and polymer plants</p>
              <p><i className="fa fa-cogs text-primary me-2"></i>Utility piping for steam, cooling water, and compressed air</p>
              <p><i className="fa fa-utensils text-primary me-2"></i>Food and beverage process piping</p>
              <p><i className="fa fa-wine-bottle text-primary me-2"></i>Distillery and dairy plant systems</p>

              <h3 className="mb-4">Our Capabilities</h3>
              
              <h4 className="mb-3"><i className="fa fa-drafting-compass text-primary me-2"></i>Process Flow Diagrams (PFDs) & Piping and Instrumentation Diagrams (P&IDs)</h4>
              <p>Developed using latest tools like AutoCAD Plant 3D, SolidWorks, and CADWorx.</p>

              <h4 className="mb-3"><i className="fa fa-tools text-primary me-2"></i>Material Selection & Routing Optimization</h4>
              <p>Based on pressure, temperature, corrosion resistance, and flow velocity.</p>

              <h4 className="mb-3"><i className="fa fa-building text-primary me-2"></i>Support Structure & Stress Analysis</h4>
              <p>Designing of pipe racks, supports, hangers, and load-bearing calculations.</p>

              <h4 className="mb-3"><i className="fa fa-tachometer-alt text-primary me-2"></i>Pumps, Valves & Instrumentation Selection</h4>
              <p>Based on hydraulic balancing and process parameters.</p>

              <h4 className="mb-3"><i className="fa fa-shield-alt text-primary me-2"></i>Hazard & Operability Studies (HAZOP)</h4>
              <p>For safety, reliability, and regulatory compliance.</p>

              <h4 className="mb-3"><i className="fa fa-link text-primary me-2"></i>Utility Integration</h4>
              <p>With ETP, RO, cooling towers, boilers, scrubbers, etc.</p>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Optimized flow paths and reduced energy loss</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Improved safety, ease of maintenance & scalability</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Faster project commissioning with minimal rework</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Process stability and higher equipment life</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Ready documentation for audits and regulatory clearances</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>25+ years of experience in process-intensive industries</p>
              <p><i className="fa fa-star text-warning me-2"></i>End-to-end support from concept to commissioning</p>
              <p><i className="fa fa-star text-warning me-2"></i>Ability to integrate process design with chemical plants and water systems</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Close coordination with client engineering and project teams</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default DesigningOfIndustrialProcessPiping;
